class Timeline extends HTMLElement {
  constructor() {
    super();
    this.dates = [...this.querySelectorAll('[data-date]')];
    this.anchors = [...this.querySelectorAll('[data-anchor]')];
    this.indicators = [...this.querySelectorAll('[data-indicator]')];
   
    
  }

  connectedCallback() {

    this.dates?.forEach((btn) => {
      const date = btn.dataset.date;
      const anchor = this.anchors.find(({ dataset }) => dataset.anchor === date);
     
      btn.addEventListener('click', () => {
        this.indicators?.forEach((indicator) => {
          indicator.classList.remove("active");
        });
        anchor.scrollIntoView({behavior: "smooth"});
        btn.querySelector('.indicator').classList.add("active");
      });
    });


    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
      
          const date = this.dates.find(({ dataset }) => dataset.date === entry.target.dataset.anchor);
          
          if (entry.isIntersecting) {
            
            date.querySelector('.indicator').classList.add("active");
          } else {
            date.querySelector('.indicator').classList.remove("active");
          }
        });
      }
    );

    this.anchors?.forEach((el, i) => {
      observer.observe(el);
    });

   
  }

}

customElements.define('timeline-block', Timeline);
